<ion-app>
  <ion-content>
    <div class="content-wrapper">
      <app-header></app-header>
      <div class="banner-image">
        <div class="overlay"></div>
        <picture>
          <source media="(width>768px)" srcset="https://cdn.amazon.auckland.ac.nz/images/suggestions/suggestions-1280w.jpg" />
          <source media="(width>1280px)" srcset="https://cdn.amazon.auckland.ac.nz/images/suggestions/suggestions-1600w.jpg" />
          <img class="cover-image" aria-hidden="true" src="https://cdn.amazon.auckland.ac.nz/images/suggestions/suggestions-768w.jpg" alt="Banner background" />
        </picture>
      </div>

      <div class="inner-content">
        <div class="margin-top-l padding-bottom-xl">
          <h1 class="title color-light">Estimated rank score calculator</h1>
          <router-outlet id="app"></router-outlet>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </ion-content>

  <app-menu></app-menu>
</ion-app>
